export const HANDLE_INPUT_TEXT = "HANDLE_INPUT_TEXT"
export const HANDLE_FIELD_ERROR = "HANDLE_FIELD_ERROR"
export const CLEAR_FIELD_ERRORS = "CLEAR_FIELD_ERRORS"
export const RESET_FORM_FIELDS = "RESET_FORM_FIELDS"
export const SET_DISABLED = "SET_DISABLED"
export const SET_HAS_FOCUS = "SET_HAS_FOCUS"
export const SET_FORM_SUCCESS = "SET_FORM_SUCCESS"
export const SET_FORM_FAIL = "SET_FORM_FAIL"
